import React from "react";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import FileBase64 from 'react-file-base64';

import Button from './Button';
import TextInput from './TextInput';

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';

export default class SendMailWidget extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            sendMailKey: Math.random(),
            editorState: EditorState.createEmpty(),
            subject: ''
        }
    }

    reset (){
        this.setState({
            sendMailKey: Math.random(),
            editorState: EditorState.createEmpty(),
            subject: ''
        });
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        console.log('as HTML:', draftToHtml(contentState));
        this.setState({ contentState});
       }

    render (){

        const that = this;
        return ( 

        <div style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container}>
            <div style={mainClass}>
                <div style={closeBtn} onClick={() => {
                    this.props.onClose();
                }}>X</div>
                <div style={title}>Invia Mail</div>
                <div>Oggetto:</div>
                <TextInput name={''} value={this.state.subject} 
                    onChange={(text) => { this.setState({subject: text})}
                } />
                <br/><br/>
                <div>Testo:</div>
                <div style={bodyMsg}>
                    <Editor
                            editorState={this.state.editorState}
                            onContentStateChange={this.onContentStateChange}
                            onEditorStateChange={(editorState) => {
                                this.setState({
                                editorState
                                });
                            }}
                            toolbarClassName="demo-toolbar-custom"
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor-custom"
                            toolbar={{
                                options: ['inline', 'fontSize', 'fontFamily', 'colorPicker'],       
                                inline: {
                                    options: ['bold', 'italic', 'underline'],
                                    bold: { className: 'bordered-option-classname' },
                                    italic: { className: 'bordered-option-classname' },
                                    underline: { className: 'bordered-option-classname' },
                                },
                            }}
                        />
                </div>
                <br/>


                <FileBase64 key={this.state.sendMailKey}
                    multiple={ false }                    
                    onDone={ (files) => {
                        this.setState({
                            files: files
                        });
                      }} />

                {this.state.files ? <div styl={{cursor: 'pointer'}} onClick={() => {
                    this.setState({
                        files: undefined,
                        sendMailKey: Math.random()
                    });
                    }
                }> Elimina allegato</div> : null}

                <br/>
                <br/>

                <Button callback={() => {
                    var subject = '';
                    var body = draftToHtml(this.state.contentState);
                    if (this.state.subject == "" || this.state.subject == undefined){
                        alert ('Check the subject');
                        return;
                    }

                    this.props.onSend(this.state.subject, body, this.state.files);
                }} title="SEND"></Button>
            </div>
            </div>
        </div>
        )
    }


}

const mainClass = {
    position: 'fixed',
    top: '25%',
    left: '25%', 
    width: '50%',
    border: '1px solid black',
    background: '#ffffff',
    padding: '2%'
}

const container = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    background: '#ffffff88',

}

const title = {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    fontWeight: 'bold'
}

const bodyMsg = {
    border: '1px solid black',
    height: '200px'
}

const inputText = {
    width: '300px',
    padding: '10px'
}

const closeBtn = {
    position: 'absolute',
    right: '1%',
    top: '1%',
    cursor: 'pointer'
}